// extracted by mini-css-extract-plugin
module.exports = {"cdvskaj":"cdvskaj","l189vxqo":"l189vxqo"};